import React, { useState } from 'react';
import { useGlobalState, useMessage } from '../../hooks';
import { userSettingValueService } from '../../services';
import { handleError, COLOR_THEME } from '../../helpers';

import { SelectButtons } from '../';

import './UserSettings.css';

export const UserSettings = () => {
  const [userSettings, setUserSettings] = useGlobalState('userSettings');

  const { showMessage } = useMessage();

  const handleInputChange = event => {
    let { name, value } = '';

    // Handle standard form inputs
    if (event.target !== undefined) {
      name = event.target.name;
      value = event.target.value;

      // If input element is a checkbox, we cannot use "value"
      if (event.target.type === 'checkbox') {
        value = event.target.checked;
      }

      // Handle custom form inputs
    } else {
      name = event.name;
      value = event.value;
    }

    // Save changes
    // Only save if value is changed
    if (userSettings[name].user_setting_value !== value) {
      updateUserSettings({ name, value });
    }
  };

  const updateUserSettings = async ({ name, value }) => {
    try {
      const data = {
        user_setting_id: userSettings[name].user_setting_id,
        user_setting_value: value,
      };

      // Persist in DB
      const res = await userSettingValueService.update({ user_setting_values: [data] }).catch(e => {
        throw e;
      });

      // Update in GUI
      setUserSettings({
        ...userSettings,
        [name]: {
          ...userSettings[name],
          user_setting_value: value,
        },
      });
    } catch (err) {
      //handleError({err, showMessage}, () => {
      //  throw err
      //})
    }
  };

  if (Object.keys(userSettings).length < 1) {
    return;
  }
  return (
    <div className={'UserSettings'}>
      <SelectButtons
        name="COLOR_THEME"
        design="bright"
        label={userSettings.COLOR_THEME.user_setting_name}
        value={userSettings.COLOR_THEME.user_setting_value}
        //title={userSettings.COLOR_THEME.user_setting_description}
        onChange={handleInputChange}
        options={[
          {
            value: COLOR_THEME.LIGHT,
            label: 'Light',
            tooltip: 'Use the default light color theme',
            icon: 'light_mode',
          },
          {
            value: COLOR_THEME.DARK,
            label: 'Dark',
            tooltip: 'Use the dark color theme',
            icon: 'dark_mode',
          },
          {
            value: COLOR_THEME.AUTO,
            label: 'Auto',
            tooltip: 'Set color theme to follow the OS/system settings',
            icon: 'auto_mode',
          },
        ]}
      />
    </div>
  );
};
